//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ordersList from './orders-list';

export default {
    name: 'my-order',
    components: {
        ordersList
    }
};
